<template>
	<div class="full-height">
		<Header @menuChange="changeMenu"></Header>
		<div class="flex-center">
			<div class="main-container" ref="main">
				<div class="nav-bar">
					<span>
						当前位置：
						<a href="/">首页</a>
						<span> > </span>
						<a href="#">史料研究</a>
						<span> > </span>
						<a href="/heroes">烈士事迹</a>
					</span>
				</div>

				<div class="flex" style="min-height: 765px;justify-content: center;width: 100%;">
					<div class="text-overflow-hidden detail-container flex" style="width: 100%;">
						<div class="menu-container">
							<a v-for="item in menus.children" :href="getMenuLink(item)">
								<div :class="{'menu-item-icontainer-active' : (nowMenuId == item.id), 'menu-item-container':true, 'flex-center' : true}">
									{{item.nameZh}}
								</div>
							</a>
						</div>

						<div class="full-width">
							<h1 class="art-title">{{data.name}}</h1>
							<div v-html="data.content" style="text-align: left;word-wrap: break-word;white-space: pre-wrap;"></div>
						</div>
					</div>

				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../../../components/Header';
	import Footer from '../../../components/Footer';
	import api from '../../../http/detail'
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				nowMenuId: 3,
				menus: {},
				data: {

				}
			}
		},
		methods: {
			getData(id) {
				const _this = this;
				api.getHeroDetail(id).then(res => {
					_this.data = res;
				})
			},
			changeMenu(allMenus) {
				this.menus = allMenus.find(item => {
					if (item.id == 11) {
						return true;
					}
				});
				var menu = this.menus.children.find(item => {
					if (item.nameZh === "烈士事迹") {
						return true;
					}
				});
				this.nowMenuId = menu.id;
			},
			getMenuLink(item) {
				if (item.isOut == 1) {
					return item.url;
				}
				return '/detail?id=' + item.id + '&pid=' + item.parentId;
			}
		},
		created() {
			var query = this.$route.query;
			this.getData(query.id);
		},
		mounted() {
			this.$refs.main.scrollIntoView()
		}
	}
</script>

<style>
	.art-title {
		height: 21px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
		line-height: 21px;
	}

	.main-container {
		width: 1200px;
	}

	.nav-bar {
		text-align: left;
		width: 100%;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		margin: 23px 0;
	}

	.detail-container {
		margin: 23px 0 30px 30px;
		padding-right: 50pxs;
		width: 100%;
	}

	.menu-container {
		margin-right: 30px;
		background: #F7F7F7;
		height: fit-content;
	}

	.menu-item-container {
		width: 166px;
		height: 55px;
		color: #666666;
	}

	.menu-item-icontainer-active {
		background: #A10000;
		color: #FFFFFF !important;
	}
</style>



// WEBPACK FOOTER //
// src/views/detail/hero/detail.vue